

export const INSPECCION_MENSAJE_AUTOINSPECCION = "tendrá una inspección de tipo: <strong>Autoinspección</strong>";
export const INSPECCION_MENSAJE_PRESENCIAL = "tendrá una inspección de tipo: <strong>Presencial</strong>";
export const INSPECCION_MENSAJE_AUTOINSPECCION_VIRTUAL = "tendrá una inspección de tipo: <strong>Presencial o Virtual Guiada</strong>";
export const INSPECCION_MENSAJE_VARIOS_TIPOS = "tendrá una inspección de tipo: <strong>Autoinspección, Presencial o Virtual Guiada</strong>";

export const INSPECCION_VALOR_AUTOINSPECCION_MAX = 20000;
export const INSPECCION_VALOR_VARIOS_TIPOS_MIN = 15001;
export const INSPECCION_VALOR_VARIOS_TIPOS_MAX = 30000;
export const INSPECCION_VALOR_PRESENCIAL_VIRTUAL_MIN = 20001;
export const INSPECCION_VALOR_PRESENCIAL_VIRTUAL_MAX = 99999;
export const INSPECCION_VALOR_PRESENCIAL_MAX = 100000;

export const INSPECCION_COTIZADORES_NO_ACEPTADOS = [
  "KilometroPaquete"
];